const icons = {
  error_outline_black:
    'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Falerts%2Ferror_outline_black.svg?alt=media&token=31c505cd-ecf2-46c0-9128-2826a84728ef',

  rule_black:
    'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Falerts%2Frule_black.svg?alt=media&token=5756f9bd-9154-4933-9166-518948f01e25',

  running_with_errors_black:
    'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Falerts%2Frunning_with_errors_black.svg?alt=media&token=68143378-25cd-4762-9b48-7900c149374d',

  trans_off:
    'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Falerts%2Ftrans_off.svg?alt=media&token=93fef758-dcff-4d1a-8292-2bcbdadf30d2',

  error_black:
    'https://firebasestorage.googleapis.com/v0/b/gnx-kcp-estrellas-kimberly-prd.appspot.com/o/error_black_24dp.svg?alt=media&token=855f9af7-836f-497b-b874-23eb91c9ed68',
};

export const CODES_ERROR = {
  PUNTORED_INCOMPLETE_DATA: {
    icon: icons.rule_black,
    message: 'Datos incompletos para realizar transacción [HE01]',
  }, //HE01:
  PUNTORED_SYSTEM_ERROR: {
    icon: icons.error_outline_black,
    message: 'Fallo en sistema [HE03]',
  }, //HE03:
  PUNTORED_QUERY_ERROR: {
    icon: icons.error_outline_black,
    message: 'Fallo en consulta [HE04]',
  }, //HE04:
  PUNTORED_REQUEST_ERROR: {
    icon: icons.error_outline_black,
    message: 'Request incorrecto [HE05]',
  }, //HE05:
  PUNTORED_INVALID_CREDENTIALS: {
    icon: icons.error_outline_black,
    message: 'Credenciales incorrectas [HE07]',
  }, //HE07:
  PUNTORED_DECLINED_TRANSACTION: {
    icon: icons.trans_off,
    message: 'Transacción rechazada [HE11]',
  }, //HE11:
  PUNTORED_NOT_FOUND_DATA: {
    icon: icons.error_black,
    message: 'No se encontraron resultados [HE12]',
  }, //HE12:
  PUNTORED_INVALID_REFERENCE: {
    icon: icons.running_with_errors_black,
    message: 'No hay convenios asociados a esta referencia [HE13]',
  }, //HE13:
  PUNTORED_ERROR: {
    icon: icons.error_black,
    message: 'No hay información asociada a esta referencia',
  }, //PUNTORED_ERROR API:
};
